// prefer default export if available
var preferDefault = function preferDefault(m) {
  return m && m.default || m;
};

exports.components = {
  "component---src-pages-404-js": function componentSrcPages404Js() {
    return import("./../../src/pages/404.js"
    /* webpackChunkName: "component---src-pages-404-js" */
    );
  },
  "component---src-pages-cart-js": function componentSrcPagesCartJs() {
    return import("./../../src/pages/cart.js"
    /* webpackChunkName: "component---src-pages-cart-js" */
    );
  },
  "component---src-pages-contact-js": function componentSrcPagesContactJs() {
    return import("./../../src/pages/contact.js"
    /* webpackChunkName: "component---src-pages-contact-js" */
    );
  },
  "component---src-pages-costumer-care-js": function componentSrcPagesCostumerCareJs() {
    return import("./../../src/pages/costumer-care.js"
    /* webpackChunkName: "component---src-pages-costumer-care-js" */
    );
  },
  "component---src-pages-index-js": function componentSrcPagesIndexJs() {
    return import("./../../src/pages/index.js"
    /* webpackChunkName: "component---src-pages-index-js" */
    );
  },
  "component---src-pages-lookbook-js": function componentSrcPagesLookbookJs() {
    return import("./../../src/pages/lookbook.js"
    /* webpackChunkName: "component---src-pages-lookbook-js" */
    );
  },
  "component---src-pages-press-js": function componentSrcPagesPressJs() {
    return import("./../../src/pages/press.js"
    /* webpackChunkName: "component---src-pages-press-js" */
    );
  },
  "component---src-pages-search-js": function componentSrcPagesSearchJs() {
    return import("./../../src/pages/search.js"
    /* webpackChunkName: "component---src-pages-search-js" */
    );
  },
  "component---src-pages-subscribe-js": function componentSrcPagesSubscribeJs() {
    return import("./../../src/pages/subscribe.js"
    /* webpackChunkName: "component---src-pages-subscribe-js" */
    );
  },
  "component---src-templates-product-page-index-js": function componentSrcTemplatesProductPageIndexJs() {
    return import("./../../src/templates/ProductPage/index.js"
    /* webpackChunkName: "component---src-templates-product-page-index-js" */
    );
  },
  "component---src-templates-product-type-index-js": function componentSrcTemplatesProductTypeIndexJs() {
    return import("./../../src/templates/ProductType/index.js"
    /* webpackChunkName: "component---src-templates-product-type-index-js" */
    );
  }
};